import script from "./MengPublish.vue?vue&type=script&setup=true&lang=js"
export * from "./MengPublish.vue?vue&type=script&setup=true&lang=js"

import "./MengPublish.vue?vue&type=style&index=0&id=0f0b9dfe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f0b9dfe"]])

export default __exports__